module.exports = __webpack_public_path__ + "img/9.5ab0c5db.jpg";